import React, { useEffect, useState } from 'react'

import { logErrorAsync } from '_lib/utility'
import { getRegions } from '_services/regions'
import { EXCEPTED_REGIONS } from '../pages/audience-creator/utils'

const useRegions = () => {
  const [regions, setRegions] = useState([])

  useEffect(() => {
    async function getData() {
      try {
        const regionsResponse = await getRegions({
          fields: ['_id', 'name', 'countries', 'subdivisions', 'cities'],
          limit: 1000,
        })

        const filteredRegions = regionsResponse.items.filter(
          (region) => !EXCEPTED_REGIONS.includes(region.name)
        )

        setRegions(filteredRegions.sort((a, b) => (a.name > b.name ? 1 : -1)))
      } catch (error) {
        logErrorAsync(error)
        toast.error(error.message)
      }
    }
    getData()
  }, [])

  return regions
}

export default useRegions
